import { Count } from 'mk2/components/NotificationsBadge';
import { FeedItemOrGroup } from 'mk2/containers/PageHeader/PageHeader.reducers';
import { memoizeOne } from 'mk2/helpers/cache';
import { getPageHeaderState, AppState } from 'mk2/reducers';
import {
    initialGroupFeedPageState,
    initialGroupFeedState,
    initialGroupFeedVirtualPageState,
    initialPostsState,
    initialState,
    orderingAndQueryKey,
    GroupFeedPageState,
    GroupFeedState,
    GroupFeedVirtualPageState, State as GroupFeedsState,
} from './GroupFeed.reducers';
import { OrderBy } from './GroupFeedPage';

export const getGroupFeedsState = (state: AppState): GroupFeedsState => {
    return state.containers.groups.groupFeed || initialState;
};

export const getGroupFeedState = (state: AppState, groupId: number): GroupFeedState => {
    return state.containers.groups.groupFeed[groupId] || initialGroupFeedState;
};

export const getGroupFeedSearchState = (state: AppState, groupId: number, orderBy: OrderBy, query: string) => {
    const groupFeedState = getGroupFeedState(state, groupId);

    const key = orderingAndQueryKey(orderBy, query);

    if (!groupFeedState.searches[key]) {
        return initialPostsState;
    }

    return groupFeedState.searches[key];
};

export const getGroupFeedPageState = (state: AppState, groupId: number, orderBy: OrderBy, query: string, page: number): GroupFeedPageState => (
    getGroupFeedSearchState(state, groupId, orderBy, query).pages[page] || initialGroupFeedPageState
);
export const getGroupFeedVirtualPageState = (state: AppState, groupId: number, orderBy: OrderBy, query: string, pageName: string): GroupFeedVirtualPageState => (
    getGroupFeedSearchState(state, groupId, orderBy, query).virtualPages[pageName] || initialGroupFeedVirtualPageState
);

const getGroupLastVisitedCountCached = memoizeOne((feedMenu: FeedItemOrGroup[], groupId: number): Count => {
    const groupItemName = `group-${groupId}`;

    const groupItem = feedMenu.reduce((acc, rootItem) => (
        rootItem.isGroup
            ? (
                rootItem.items.reduce((acc2, item) => (
                    item.name === groupItemName ? item : acc2
                ), acc)
            ) : (
                rootItem.name === groupItemName ? rootItem : acc
            )
    ));

    return groupItem ? groupItem.lastVisitCount : null;
});

export const getGroupLastVisitedCount = (state: AppState, groupId: number) => (
    getGroupLastVisitedCountCached(getPageHeaderState(state).feedMenu, groupId)
);
